import { type GetMyCurrentExamPaperQueryResponse } from '@exam-room/graphql';

type ExamPaper = GetMyCurrentExamPaperQueryResponse['erGetMyCurrentExamPaper'];

export function generateExamSession(examPaper: ExamPaper) {
  return {
    id: 'preview-exam-session',
    examPaperId: examPaper.id,
    examEventId: null,
    startedAt: new Date(),
    endedAt: null,
    examRoomAnswer: {
      examRoomExamPaperItems: examPaper.examPaperItems.map((examPaperItem) => {
        return {
          examPaperItemId: examPaperItem.id,
          questionId: examPaperItem.question?.id,
          refId: null,
          answer: {
            type: 'HTML',
          },
          isBookmark: false,
        };
      }),
      __typename: 'ExamRoomAnswer',
    },
    __typename: 'ExamSession',
  };
}
